export default "__VITE_ASSET__BSa74Z2m__"